import { BaseModel } from '../../../../../shared/model/base/BaseModel';
import {CURRENT_USER} from '../../../../../js/resources/SessionObjects';

export const localStorageFilterKey = 'CFD_FILTER_GROUP_TASK';

export const taskTypes = {
    spraying: 'SPRAYING',
    scouting: 'SCOUTING',
    droneFlight: 'DRONEFLIGHT'
};

export const executionStates = {
    planned: 'PLANNED',
    executed: 'EXECUTED',
    overdue: 'OVERDUE',

};

export const assignmentStates = {
    unacknowledged: 'UNACKNOWLEDGED',
    rejected: 'REJECTED',
    unassigned: 'UNASSIGNED',
    accepted: 'ACCEPTED',
};

/**
 * @class TaskFilterGroupState
 * @extends Backbone.Model
 */
export class TaskFilterGroupState extends Backbone.Model {

    get defaults () {

        return {
            available: {
                taskTypes: new Backbone.Collection(),
                executionStates: new Backbone.Collection(),
                assignmentStates: new Backbone.Collection(),
            },

            filtered: {
                taskTypes: new Backbone.Collection(),
                executionStates: new Backbone.Collection(),
                assignmentStates: new Backbone.Collection(),
            },

            filteredTaskDate: new Backbone.Model({
                start: undefined,
                end: undefined,
            }),

            headFilter: new Backbone.Model(this.getDefaultHeadFilter()),

            serializedFilters: this.getDefaultSerializedFilter(),
        };
    }

    getDefaultHeadFilter() {
        return {
            isAssignedToMe: false,
        };
    }

    getDefaultSerializedFilter() {
        return {
            taskTypes: [],
            executionStates: [],
            assignmentStates: [],
            headFilter: this.getDefaultHeadFilter(),
            taskDate: {
                start: '',
                end: '',
            },
        };
    }

    initialize () {

        const {
            available,
            filtered,
        } = this.attributes;

        const comp = 'name';

        Object.keys(available).forEach( (key) => {
            available[key].comparator = comp;
        });

        Object.keys(filtered).forEach( (key) => {
            filtered[key].comparator = comp;
        });
    }

    fetchData () {

        return new Promise((resolve) => {

            const {
                available,
                filtered,
            } = this.attributes;

            // reset all available collections
            available.taskTypes.reset(this.getModelArray(taskTypes));

            if (!CURRENT_USER.isBrazilUser()) {
                available.taskTypes.remove(available.taskTypes.find({code: taskTypes.droneFlight}));
            }

            available.executionStates.reset(this.getModelArray(executionStates));
            available.assignmentStates.reset(this.getModelArray(assignmentStates));

            // reset all filtered collections
            Object.keys(filtered).forEach((key) => {
                filtered[key].reset();
            });

            this.initializeFilter();

            resolve();
        });
    }

    getModelArray(codesObj) {

        const models = Object.keys(codesObj).map((key) => {
            return new Backbone.Model({
                code: codesObj[key],
                name: __(key !== 'overdue' ? codesObj[key] : 'CROSS_FARM_DASHBOARD_LAYOUT_OVERDUE'),
            });
        });

        return models;
    }

    initializeFilter () {

        let filters = localStorage.getItem(localStorageFilterKey);

        try {
            const parsed = JSON.parse(filters);

            if(parsed) {

                this.set('serializedFilters', parsed);

                const { 
                    available,
                    filtered,
                } = this.attributes;

                this.setAvailableAndFilteredItems(parsed.taskTypes, 'code', available.taskTypes, filtered.taskTypes);

                this.setAvailableAndFilteredItems(parsed.executionStates, 'code', available.executionStates, filtered.executionStates);

                this.setAvailableAndFilteredItems(parsed.assignmentStates, 'code', available.assignmentStates, filtered.assignmentStates);
                
                if (parsed.headFilter) {

                    this.attributes.headFilter.set(parsed.headFilter);
                }

                if(parsed.taskDate) {

                    const {
                        start,
                        end,
                    } = parsed.taskDate;

                    this.attributes.filteredTaskDate.set({
                        start: start && moment(start).tz(BaseModel.timezone) || undefined,
                        end: end && moment(end).tz(BaseModel.timezone) || undefined,
                    });
                }
            }
        }
        catch (e) {

            const defaultFilters = this.getDefaultSerializedFilter();

            this.set('serializedFilters', defaultFilters);

            this.removeFilterFromLocalStorage();
        }
    }

    setAvailableAndFilteredItems(array, key, availableItems, filteredItems) {
        if (array.length) {

            array.forEach((val) => {
                let model = availableItems.find({[key]: val});

                availableItems.remove(model);
                filteredItems.add(model);
            });
        }
    }

    resetAllFilters () {

        const {
            available,
            filtered,
            filteredTaskDate,
        } = this.attributes;

        Object.keys(available).forEach((key) => {
            this.resetCollection(available[key], filtered[key]);
        });

        this.attributes.headFilter.set(this.getDefaultHeadFilter());

        filteredTaskDate.set({
            start: undefined,
            end: undefined,
        });
    }

    resetCollection(availableCollection, filteredCollection) {
        
        if(filteredCollection.length) {
            availableCollection.add(filteredCollection.models);

            filteredCollection.reset();
        }
    }

    updateFilter () {

        const {
            taskTypes,
            executionStates,
            assignmentStates,
        } = this.attributes.filtered;

        const { start, end } = this.attributes.filteredTaskDate.attributes;

        const serializedFilters = {
            taskTypes: taskTypes.pluck('code'),
            executionStates: executionStates.pluck('code'),
            assignmentStates: assignmentStates.pluck('code'),
            headFilter: this.attributes.headFilter.attributes,
            taskDate: {
                start: start && start.valueOf() || '',
                end: end && end.valueOf() || '',
            },
        };

        this.set('serializedFilters', serializedFilters);

        try {
            localStorage.setItem(localStorageFilterKey, JSON.stringify(serializedFilters));
        }
        catch (e) {

            console.error('Error while saving ' + localStorageFilterKey);

            this.removeFilterFromLocalStorage();
        }
    }

    removeFilterFromLocalStorage() {
        try {
            localStorage.removeItem(localStorageFilterKey);
        }
        catch (error) {
            console.error('Error while removing ' + localStorageFilterKey);
        }
    }
}


// WEBPACK FOOTER //
// ./layout/CrossFarmDashboardLayout/Filters/GroupViews/TaskFilterGroupView/TaskFilterGroupState.js